/* eslint-disable one-var */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable no-sequences */
/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
/* eslint-disable prettier/prettier */



function dotoAddToCartNoPopup(data) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function(response) {
                resolve(response);
            },
            error: function(error) {
                console.error("Error al agregar al carrito", error);
                reject(error);
            }
        });
    });
}






function dotoAddToCart(data, textNotification='Producto agregado al carrito') {
    return new Promise((resolve, reject) => {

        // console.log(window.Shopify.getCart())
        // eslint-disable-next-line no-var
        var a=$(this);
        a.css("pointer-events","none").addClass("loading"),
        $(".lookbook-modal").modal("hide"),
        $.ajax( {
        type:"POST",
        url:"/cart/add.js",
        data: data,
        dataType:"json",
        success:function(t) {
            $.get("/cart?view=json",function(t) {
            $("#cart-info").html(t)
            })
            .always(function() {
                "show_popup"==theme.cart_status,$(".form-cart__extent").length,updateMiniCart(),PopupAddToCart(),a.css("pointer-events","auto").removeClass("loading"),$(".cart_extend").removeClass("act"),$(".cart_extend--label").removeClass("act")
            })
        },
        complete:function() {
            $(".product-form__cart-submit").parents(".cart_popup_opened").length||$("body").removeClass("cart_popup_opened"),$("body").removeClass("loading"),$(".nov-close, .cart_popup_opened .nov-ready").on("click",function() {
                $("body").hasClass("template-cart")&&window.location.reload()
            }),
            "show_minicart"==theme.cart_status&&setTimeout(function() {
                $("#desktop_cart").addClass("active"),$(".sidebar-overlay").addClass("act")
            },
            // 1e3),$(document).find(".nov-close")
            1e3),$(document).find(".nov-close").trigger("click")
        },
        error:function(t,i) {
            // a.removeClass("loading").css("pointer-events","auto").find(".add-to-cart-text").text(window.inventory_text.sold_out)
        }
        })
        .done(function() {
            $("body").removeClass("loading")
        })
        setTimeout(function() {
            $.ajax( {
            url:"/cart/?view=upsell",dataType:"html",type:"GET",beforeSend:function() {
                $("body").addClass("cart_popup_opened")
            },
            success:function(t) {
                $.magnificPopup.open( {
                items: {
                    src:'<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">'+t+"</div></div>",type:"inline"
                },
                removalDelay:500,closeMarkup:'<i class="close-icon nov-close"></i>',callbacks: {
                    beforeOpen:function() {
                    this.st.mainClass="nov-move-horizontal"
                    },
                    open:function() {
                    PopupAddToCart(),
                        rtl=!!$("html").hasClass("lang-rtl"),$(".product-related-slider").slick( {
                        nextArrow:'<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',prevArrow:'<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',rtl:rtl,slidesToShow:3,slidesToScroll:3,arrows:!1,dots:!0,infinite:!0,responsive:[ {
                            breakpoint:992,settings: {
                            slidesToShow:2,slidesToScroll:2
                            }
                        },
                        {
                            breakpoint:768,settings: {
                            slidesToShow:1,slidesToScroll:1
                            }
                        }
                        ]
                    })
                    },
                    change:function() {
                    },
                    close:function() {
                    $("body").hasClass("template-cart")?window.location.reload():($("body").removeClass("cart_popup_opened"),$("body").removeClass("loading"),$("#content_cart__popup_nt").empty())
                    }
                }
                })
            },
            complete:function() {
                if(PopupAddToCart(),$(".loader").remove(),a) {
                var t='<div class="cart-message"><i class="zmdi zmdi-notifications-active"></i><strong>'+textNotification+"</strong> - "+theme.strings.cart_message_html+"</div>";
                $(".cart-popup-heading").after(t),setTimeout(function() {
                    $(".cart-message").slideUp()
                },
                4e3)
                }
            },
            error:function() {
                $(".loader").remove()
            }
            })
        }, 1000); 
    });
}

function updateMiniCart() { 
    window.Shopify.getCart(function(t) {
        doUpdateMiniCart(t)
    })
}

function doUpdateMiniCart(t) {
    $(".cartItemsCount, #CartCountCavas").text(t.item_count),$("#header-cart-total").html(window.Shopify.formatMoney(t.total_price,theme.moneyFormat)),$(".cart-popup-heading span").html("Tienes "+t.item_count+" producto(s) en tu carrito"),0==t.item_count?$(".CartCount").parent(".site-header__cart-count").hide():$(".CartCount").parent(".site-header__cart-count").show()
}

function PopupAddToCart() {
    function t(t,a) {
        $(".cart__popup").addClass("loading"),$.ajax( {
            type:"POST",url:"/cart/change.js",data:"quantity="+a+"&id="+t,dataType:"json",success:function(i) {
                jQuery.get("/cart?view=up_ajax",function(i) {
                        i=jQuery(i);
                        var e=jQuery(i),o=jQuery(e.get(0)).html(),n=jQuery(e.get(2)).html(),s=$(".cart__popup #"+t).find(".cart__popup-total .amount");
                        $(".cart__popup #"+t).find(".cart__popup-qty--input").val(a);
                        var r=parseFloat(s.data("price"))*a;
                        s.html(Shopify.formatMoney(r,theme.moneyFormat)),$("#cart__popup_total").html(o),$("#threshold_bar_popup").html(n)
                })
                .always(function() {
                    $(".cart__popup").removeClass("loading")
                }),
                $.get("/cart?view=json",function(t) {
                    $("#cart-info").html(t)
                })
                .always(function() {
                    updateMiniCart()
                })
            },
            error:function(t,a) {
                $(".cart__popup").removeClass("loading")
            }
        })
    }
    $(document).on("click",".cart__popup-qty",function(a) {
        a.preventDefault();
        var i=$(this),e=i.siblings(".cart__popup-qty--input"),o=e.attr("data-id"),n=parseFloat(e.val()),s=parseFloat(e.attr("step")),r=parseFloat(e.attr("min")),d=parseFloat(e.attr("max"));
        if(i.hasClass("cart__popup-qty--plus")) {
            var c=n+s;
            if(c>d&&d>0) {
                e.val(d);
                return
            }
        }
        else if(i.hasClass("cart__popup-qty--minus")) {
            var c=n-s;
            if(0===c) {
                var l=parseInt(e.attr("value"));
                e.val(l),i.parents(".cart__popup-item").find(".cart__popup-remove").trigger("click");
                return
            }
            if(c<r)return;
            if(n<0) {
                alert("Invalid");
                return
            }
        }
        t(o,c)
    });
    var a=!0;
    $(document).on("click",".cart__popup-remove",function(t) {
        t.preventDefault();
        var i=$(this),e=i.siblings(".cart__popup-quantity").find(".cart__popup-qty--input"),o=i.find("a").attr("data-product-id"),n=parseInt(e.val());
        $ptitle=i.parent(".cart__popup-item").find(".cart__popup-title a").text(),$(".cart__popup .cart-message").slideDown(),a&&(setTimeout(function() {
            $(".cart__popup .cart-message").slideUp()
        },
        4e3),a=!1,setTimeout(function() {
            a=!0
        },
        4e3)),$(".cart__popup").addClass("loading"),$.ajax( {
            type:"POST",url:"/cart/change.js",data:"quantity=0&id="+o,dataType:"json",success:function(t) {
                jQuery.get("/cart?view=up_ajax",function(t) {
                })
                .always(function(t) {
                    t=jQuery(t);
                    var a=jQuery(t),e=jQuery(a.get(0)).html(),s=jQuery(a.get(2)).html();
                    $("#cart__popup_total").html(e),$("#threshold_bar_popup").html(s),$(".cart__popup #"+o).addClass("hide"),n>0?$("#"+o+" input").val(n):$(".cart__popup #"+o+" input").val(1),$(".cart__popup .cart-message").html('<i class="rbb-icon-delete-outline-2"></i> <strong>'+$ptitle+"</strong> - has been removed into your shopping cart."),$(".cart__popup .cart-message").removeClass("removed").addClass("removed"),$(".cart__popup").removeClass("loading"),i.parents(".cart__popup-item").remove()
                }),
                $.get("/cart?view=json",function(t) {
                    $("#cart-info").html(t)
                })
                .always(function() {
                  updateMiniCart()
                })
            }
        })
    })
}